module.exports = __webpack_public_path__ + "img/gyant_xl_light_natural_ba_detail_rsh8.6e74fda3.jpg";